// Copied part of code from bold product options app documentation
// https://help-shopcircle.freshdesk.com/support/solutions/articles/19000157642-custom-work-image-change-on-swatch-or-radio-button-click-for-free-themes-like-dwan-crave-taste-

function observeDOM() {
  var observer = new MutationObserver(function(mutationsList) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
        var radioInputs = document.querySelectorAll('.bold_option.bold_option_radio .bold_option_value_element input');
        var swatchInputs = document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_value_element input');

        radioInputs.forEach(function(input) {
          if(!input.classList.contains('po-initialised')) {
            input.addEventListener('change', function(event) {
              window.WhatSub.dispatch('PO_INPUT_CHANGED', event)
            });
            input.classList.add('po-initialised')
          }
        });

        swatchInputs.forEach(function(input) {
          if(!input.classList.contains('po-initialised')) {
            input.addEventListener('change', function(event) {
              window.WhatSub.dispatch('PO_INPUT_CHANGED', event)
            });
            input.classList.add('po-initialised')
          }
        });

        observer.disconnect();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', function() {
  observeDOM();
});
